import { render, staticRenderFns } from "./BnTarifaDatas.vue?vue&type=template&id=4d318810&scoped=true&"
import script from "./BnTarifaDatas.vue?vue&type=script&lang=js&"
export * from "./BnTarifaDatas.vue?vue&type=script&lang=js&"
import style0 from "./BnTarifaDatas.vue?vue&type=style&index=0&id=4d318810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d318810",
  null
  
)

export default component.exports